<!-- Resources Library Header -->
<header class="resources-header">
  <div class="container">
    <div class="header-content">
      <div class="icon-title">
        <svg class="book-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 7v14"></path><path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"></path></svg>
        <h1>{{getTranslation('title')}}</h1>
      </div>
      <p class="subtitle">{{getTranslation('subtitle')}}</p>
    </div>
  </div>
</header>

<!-- Search Section -->
<section class="search-section">
  <div class="container">
    <div class="search-box">
      <div class="search-field">
        <i class="fa fa-search search-icon"></i>
        <input 
          type="text" 
          class="search-input" 
          [(ngModel)]="searchText"
          (input)="searchResources()"
          [placeholder]="getTranslation('searchPlaceholder')">
        <button 
          *ngIf="searchText" 
          class="clear-btn" 
          (click)="clearSearch()">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <!-- Sort control (inline with search-field) -->
      <div class="sort-controls">
        <label class="sort-label">Sort:</label>
        <select class="sort-select" [(ngModel)]="sortOption" (change)="sortResources()">
          <option value="default">Display order</option>
          <option value="title_asc">Name A → Z</option>
          <option value="title_desc">Name Z → A</option>
          <option value="newest">Newest</option>
          <option value="oldest">Oldest</option>
        </select>
      </div>
    </div>
  </div>
</section>

<!-- Resources Content -->
<section class="resources-content">
  <div class="container">
    <div *ngIf="loading" class="no-results">
      <i class="fa fa-spinner fa-spin"></i>
      <p>{{getTranslation('loadingResources')}}</p>
    </div>
    
    <!-- No Results Message -->
    <div *ngIf="!loading && filteredResources.length === 0" class="no-results">
      <i class="fa fa-search"></i>
      <p>{{getTranslation('noResults')}}</p>
      <button class="btn btn-primary" (click)="clearSearch()">{{getTranslation('clearSearch')}}</button>
    </div>

    <!-- Resource Cards -->
    <div *ngFor="let resource of filteredResources" class="target-card">
      <div class="target-header">
        <h3 class="target-title">
          {{getResourceName(resource)}}
        </h3>
        <div class="publication-year">
          <span>{{getTranslation('year')}}:</span> {{resource.year || '-'}}
        </div>
      </div>

      <!-- Resource Link -->
      <div class="indicators-list">
        <div class="indicator-item">
          <div class="indicator-icon">
            <span class="link-arrow-icon" aria-hidden="true">&#8594;</span>
          </div>
          <div class="indicator-content">
            <a
              *ngIf="getExternalLink(resource)"
              class="indicator-name"
              [href]="getExternalLink(resource)"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{getResourceLinkText(resource)}}
            </a>
            <span *ngIf="!getExternalLink(resource)" class="indicator-name">-</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>

<!-- Footer Info - Only for Admin -->
<section class="footer-info" *ngIf="isAdminUser">
  <div class="container">
    <div class="info-box">
      <i class="fa fa-info-circle"></i>
      <p>{{getTranslation('footerInfo')}}</p>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// ./src/app/sdg/resource-quest/resource-quest.component.html